import Vue from '@/shared/node_modules/vue';
import { Settings } from "../services/configService";

export class ClientErrorReporter {
  private static sent = new Set<string>();
  private static botUserAgent = /bot|crawler|spider|externalagent|externalhit|headless/i;

  static install() {
    if (ClientErrorReporter.botUserAgent.test(navigator.userAgent)) return;
    Vue.config.errorHandler = (err: any, vm: any, info: string) => {
      console.error(err);
      ClientErrorReporter.report(err, info);
    };
    window.addEventListener("error", (e: ErrorEvent) => ClientErrorReporter.report(e.error || e.message, "window.onerror"));
    window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => ClientErrorReporter.report(e.reason, "unhandledrejection"));
  }

  static report(err: any, info: string) {
    try {
      const message = err && err.message ? err.message : String(err);
      const key = message + "|" + window.location.pathname;
      if (ClientErrorReporter.sent.has(key)) return;
      ClientErrorReporter.sent.add(key);
      const body = JSON.stringify({
        message,
        stack: err && err.stack ? err.stack : "",
        url: window.location.href,
        info,
      });
      navigator.sendBeacon(`${Settings.HostName}/api/publicclienterrors`, new Blob([body], { type: "application/json" }));
    } catch (e) {
      console.error(e);
    }
  }
}
